import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const Download = ({ color, size, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '22px'}
      height={size || '22px'}
      color={color || 'currentColor'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M14.703,9.4L11,13.103L7.297,9.4"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
      />
      <path
        d="M18.282,14.054v2.975c0,0.69-0.56,1.25-1.25,1.25H4.971c-0.69,0-1.25-0.56-1.25-1.25v-2.975"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
      />
      <path d="M11,12.983V3.758" stroke={color || 'currentColor'} strokeWidth="1.5" />
    </StyledSvg>
  );
};
